import { CCard, CLabel, CSelect } from "@coreui/react";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

export const RecordSorter = (props) => {
  const [sortByColIndex, setSortByColIndex] = useState(0);

  useEffect(() => {
    if (props.fields && props.fields.length > 0) {
      const index = props.fields?.findIndex(
        (f) =>
          f.field_name === props.sortByCol.field.name &&
          f.column === props.sortByCol.field.column &&
          f.modelOutputName === props.sortByCol.field.model_output_name,
      );
      setSortByColIndex(index);
    }
  }, [props.fields, props.sortByCol]);

  return (
    <CCard
      style={{
        marginRight: "20px",
        paddingTop: "5px",
        paddingBottom: "5px",
        paddingRight: "10px",
        paddingLeft: "10px",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <CLabel
          htmlFor="record-sorter-switch"
          style={{ minWidth: "50px", marginBottom: 0 }}
        >
          Sort By
        </CLabel>
        <CSelect
          id="record-sorter-switch"
          data-testid={`${props.testIdPrefix}-select-sort`}
          style={{ width: "100%", margin: "5px" }}
          value={sortByColIndex}
          onChange={(e) => {
            const index = parseInt(e.target.value, 10);
            setSortByColIndex(index);
            const selectedField = props.fields[index];
            let field = {
              name: selectedField.field_name,
              column: selectedField.column,
              group: "dataset",
            };
            if (selectedField.column === "automated_data_record_predictions") {
              field.model_output_name = selectedField.modelOutputName;
            }
            props.setSortByCol({
              field: field,
              isAscending: props.isAscending,
            });
          }}
        >
          {props.fields?.map((propField, index) => {
            return (
              <option key={propField.id} value={index}>
                {propField.display_name
                  ? propField.display_name
                  : propField.field_name}
              </option>
            );
          })}
        </CSelect>
        <span
          data-testid={`${props.testIdPrefix}-btn-sort-dir`}
          onClick={() => {
            const updatedIsAscending = !props.isAscending;
            props.setisAscending(updatedIsAscending);
            const selectedField = props.fields[sortByColIndex];
            if (!selectedField) {
              return;
            }
            const field = {
              name: selectedField.field_name,
              column: selectedField.column,
              group: "dataset",
            };
            if (selectedField.column === "automated_data_record_predictions") {
              field.model_output_name = selectedField.modelOutputName;
            }
            props.setSortByCol({
              field: field,
              isAscending: updatedIsAscending,
            });
          }}
          style={{
            display: "inline-block",
            transform: props.isAscending ? "rotate(180deg)" : "none",
            cursor: "pointer",
            marginLeft: "5px",
          }}
        >
          ▲
        </span>
      </div>
    </CCard>
  );
};

RecordSorter.propTypes = {
  fields: PropTypes.array.isRequired,
  isAscending: PropTypes.bool.isRequired,
  setisAscending: PropTypes.func.isRequired,
  sortByCol: PropTypes.object.isRequired,
  setSortByCol: PropTypes.func.isRequired,
  testIdPrefix: PropTypes.string,
};

RecordSorter.defaultProps = {
  fields: [],
  isAscending: true,
  setisAscending: () => {},
  testIdPrefix: "sorter",
};
